import { useEffect, useState } from 'react'

const DEFAULT_TIMEOUT_MS = 10000
const INTERACTION_EVENTS = [
  'pointerdown',
  'keydown',
  'scroll',
  'touchstart',
  'wheel'
] as const

export const useFirstInteraction = (
  timeoutMs: number = DEFAULT_TIMEOUT_MS
): boolean => {
  const [hasInteracted, setHasInteracted] = useState(false)

  useEffect(() => {
    if (hasInteracted) return

    let timer = 0

    const settle = () => {
      window.clearTimeout(timer)
      INTERACTION_EVENTS.forEach(event =>
        window.removeEventListener(event, settle)
      )
      setHasInteracted(true)
    }

    timer = window.setTimeout(settle, timeoutMs)

    INTERACTION_EVENTS.forEach(event =>
      window.addEventListener(event, settle, { once: true, passive: true })
    )

    return () => {
      window.clearTimeout(timer)
      INTERACTION_EVENTS.forEach(event =>
        window.removeEventListener(event, settle)
      )
    }
  }, [hasInteracted, timeoutMs])

  return hasInteracted
}
